import * as React from "react";
import {
  FormControl,
  Grid,
  InputLabel,
  MenuItem,
  Select,
} from "@material-ui/core";
import { LoadingSpinner } from "../../../../../../utils/LoadingSpinner";
import { API } from "aws-amplify";
import ErrorResponse from "./ErrorResponse";

interface IProps {
  personId?: string;
}

interface IState {
  addresses: any[];
  exception: boolean;
  legacyAddressId: string;
  message: string;
}

class AddressSection extends React.Component<IProps, IState> {
  constructor(props: IProps) {
    super(props);

    this.state = {
      addresses: [],
      exception: false,
      legacyAddressId: "",
      message: "",
    };

    this.handleAddress = this.handleAddress.bind(this);
  }

  public render() {
    const showLoadingSpinner = this.state.addresses.length === 0;
    if (!showLoadingSpinner && this.state.legacyAddressId.length === 0) {
      for (const address of this.state.addresses) {
        this.setState({ legacyAddressId: address.legacyAddressId });
        break;
      }
    }

    return (
      <Grid item xs={12}>
        <Grid
          container
          direction="column"
          justify="center"
          alignItems="center"
          spacing={3}
        >
          {showLoadingSpinner && !this.state.exception && <LoadingSpinner />}

          {!showLoadingSpinner && !this.state.exception && (
            <Grid item xs>
              <FormControl>
                <InputLabel>Addresses (Required)</InputLabel>
                <Select
                  value={this.state.legacyAddressId}
                  style={{ width: 225 }}
                  onChange={this.handleAddress}
                >
                  // @ts-ignore
                  {this.state.addresses.map((customerAddress) => (
                    <MenuItem value={customerAddress.legacyAddressId}>
                      <em>{customerAddress.mailingAddress}</em>
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          )}

          {this.state.message && (
            <ErrorResponse
              message={this.state.message}
              dialogTitle={"Address Response Exception"}
            />
          )}
        </Grid>
      </Grid>
    );
  }

  public componentDidMount() {
    this.getAddresses();
  }

  public handleAddress(event: React.ChangeEvent<HTMLSelectElement>) {
    this.setState({ legacyAddressId: event.target.value });
  }

  public getState() {
    return this.state;
  }

  private getAddresses() {
    const apiName = "ApaqPortalAPI";
    const path =
      "/customer/address/get-addresses?personId=" + this.props.personId;

    API.get(apiName, path, {})
      .then((value: any) => {
        const result = [];
        for (const entry of value.customerAddresses) {
          if (entry.active) {
            result.push(entry);
          }
        }

        this.setState({ addresses: result });

        if (result.length === 0) {
          this.setState({ message: "No address found on customer account." });
          this.setState({ exception: true });
        }
      })
      .catch((error) => {
        console.error(error);
        this.setState({ message: error.response.data.message });
        this.setState({ exception: true });
      });
  }
}

export default AddressSection;
